require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./interviste-paolo-fumagalli.json") })
        }
      }, "path---interviste-paolo-fumagalli");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---interviste-paolo-fumagalli!./.cache/json/interviste-paolo-fumagalli.json
// module id = 685
// module chunks = 231608221292675